import Issues from './Issues';

export default Issues;
